module.exports = __webpack_public_path__ + "img/navLogo.aed81b4e.png";